import * as d3 from 'd3'

import { getSvgDefs } from '@aytm/app/stats/page/question-views/hm/components/chart/lib/render/svg-defs'

import { CLUSTER_STROKE_WIDTH, VIEW_MODES } from '@aytm/app/stats/page/question-views/hm/components/chart/lib/constants'
import { createSvgRoot } from '@aytm/app/stats/page/question-views/hm/components/chart/lib/render/svg-root'

export const drawClusters = (container, options) => {
  const {
    id,
    clusters,
    image,
    scale,
    activeClusterId,
    clusterFormMode,
    width,
    height,
    onShowClusterPopup,
    onClusterMouseLeave
  } = options
  const imageHeight = image?.original?.height

  if (!clusters?.length) return

  const svg = createSvgRoot(container, {
    id,
    viewMode: VIEW_MODES.CLUSTERS,
    width,
    height,
    scale
  })

  const defs = svg.append('defs')
  defs.html(getSvgDefs(id, VIEW_MODES.CLUSTERS))

  // Sort clusters by area (largest first)
  const clustersSorted = [...clusters].sort((c1, c2) => {
    const a1 = Math.abs(d3.polygonArea(c1.border))
    const a2 = Math.abs(d3.polygonArea(c2.border))
    return a2 - a1
  })

  clustersSorted.forEach(cluster => {
    const clusterUid = cluster.uid.replace('@', '').replace('.', '')
    const isHidden = cluster.off || (cluster.uid === activeClusterId && clusterFormMode === 'edit')

    const polygon = svg
      .append('polygon')
      .attr('id', `hm-cluster-${clusterUid}-${id}`)
      .attr('points', cluster.border.map(item => `${item[0]},${imageHeight - item[1]}`).join(' '))
      .attr('data-type', cluster.clusterType)
      .style('fill', cluster.color)
      .style('fill-opacity', 0)
      .style('stroke', cluster.color)
      .style('stroke-width', `${CLUSTER_STROKE_WIDTH / scale}px`)
      .style('visibility', isHidden ? 'hidden' : 'visible')

    // Mouse events for cluster popup
    polygon
      .on('mouseenter', function () {
        if (!cluster.off && clusterFormMode === 'off') {
          d3.select(this).attr('class', 'active')
          onShowClusterPopup(this, cluster)
        }
      })
      .on('mouseleave', function () {
        d3.select(this).attr('class', '')
        onClusterMouseLeave()
      })

    // Add cluster attributes
    if (cluster.attributes && Object.keys(cluster.attributes).length > 0) {
      Object.keys(cluster.attributes).forEach(key => {
        polygon.attr(`data-${key}`, cluster.attributes[key])
      })
    }
  })
}
